import React from "react";

import Layout from "../components/ui/Layout";
import Header from "../components/ui/Header";
import { Box } from "rebass/styled-components";
import Section from "../components/ui/Section";
import Seo from "../components/ui/Seo";
const MortgageIndex = ({ data }) => {
  const iframe =
    '<iframe src="https://www.visionabacus.net/Tools/B3/SuiteA/G100/Loan_Repayment_Calculator/Century21HomeLoans" width="100%" height="800" frameborder="0" style="border:0;" allowfullscreen=""></iframe>';

  const iframeHHTML = () => {
    return {
      __html: iframe
    };
  };
  return (
    <Layout>
      <Seo title="Mortgage Calculator" />
      <Header title="Mortgage Calculator" />

      <Section>
        <Box p={3}></Box>
        <div dangerouslySetInnerHTML={iframeHHTML()} />
      </Section>
    </Layout>
  );
};
export default MortgageIndex;
